<template>
	<div>
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">预约看板</div>

			<div class="mt20 ">
				<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
					<a-radio-button :value="item.mendian_id" v-for="(item, index) in mendians" :key="index">
						{{ item.name }}
					</a-radio-button>
				</a-radio-group>
			</div>

			<div class="mt20">
				<div class="form-search-box ">
					<a-form layout="inline">

						<a-form-item label="治疗师">
							<a-input v-model="search.technician" placeholder="请输入治疗师姓名/手机号"></a-input>
						</a-form-item>
						
						<a-form-item label="客户">
							<a-input v-model="search.member" placeholder="请输入客户姓名/手机号"></a-input>
						</a-form-item>

						<!-- <a-form-item label="状态">
							<a-select v-model="search.status" style="width: 240px;">
								<a-select-option :value="0">全部状态</a-select-option>
								<a-select-option :value="1">待确认</a-select-option>
								<a-select-option :value="4">待到店</a-select-option>
								<a-select-option :value="8">已完成</a-select-option>
								<a-select-option :value="-1">已取消</a-select-option>
							</a-select>
						</a-form-item> -->
						
						<a-form-item>
							<a-button @click="searchAct" type="primary">查询</a-button>
							<a-button @click="cancelAct" class="ml10">取消</a-button>
						</a-form-item>
					</a-form>
				</div>
			</div>

			<div class="mt20">
				<div class=" pd30 bg-w" style="min-height: 800px;">
					<div class="flex alcenter">
						<!-- <a-button type="primary" icon="plus" @click="addAppointmentAct()">新增预约</a-button> -->

						<div class="ml30 flex wrap">
							<div class="flex alcenter mr30" v-for="(item, index) in settings">
								<div class="setting-item" :style="{ background: item.mainColor }"></div>
								<div class="ml8 ft14 ftw600 cl-info">{{ item.status_means }}</div>
							</div>
						</div>
					</div>

					<div class="mt30">
						<div class="kanban-table-header">
							<div class="flex alcenter">
								<div class="kanban-table-header-left">
									<div class="switch-btn" @click="switchTable()">切换看板</div>
								</div>
								<div style="width: 100%" class="kanban-table-header-right">
									<div class="flex alcenter space" style="height: 100%;">
										<div class="last-week-button" @click="getUpWeek()">
											<div class="flex alcenter center">
												<i class="iconfont iconlast ft12 cl-info" />
												<div class="ml2">上一周</div>
											</div>
										</div>

										<div style="width: 100%;" class="flex alcenter">
											<template v-for="(item, index) in getDays">
												<div class="this-week-item flex alcenter center on" v-if="index == selectIndex">
													<div>{{ item.today == 1 ? '今天' : '周' + item.wd }}</div>
													<div class="ml4">{{ item.md }}</div>
												</div>
												<div v-else class="this-week-item flex alcenter center" @click="changeDay(index)">
													<div class="cl-main">周{{ item.wd }}</div>
													<div class="ml4">{{ item.md }}</div>
												</div>
											</template>
										</div>

										<div class="next-week-button" @click="getDownWeek()">
											<div class="flex alcenter center">
												<div>下一周</div>
												<i class="iconfont iconnext ft12 cl-theme ml2" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 看板一 -->
						<a-table v-if="theTableVisible" :columns="columns" :data-source="mockData" :pagination="false" :scroll="{ x: mockDataTechnician.length * 150 }" bordered>
							<div :slot="`bookDetail-${technician.technician_id}`" slot-scope="text, record,index"
								v-for="(technician, ii) in mockDataTechnician" :key="technician.technician_id">
								<template v-for="(book, ii) in record.bookProject">
									<div class="kanban-table-item" v-if="book.technician_id === technician.technician_id">
										<!-- 预约详情 -->
										<div class="ml10 pr15">
											<div>
												<div class="flex alcenter mt8">
													<!-- <div :style="{background: setting[book.status].mainColor}">{{book.start_time}}-{{book.end_time}}</div> -->
													<div :style="{color:setting[book.status].projectColor}" class="ml8 ft14 ftw400">{{book.project_name}}</div>
												</div>
												<div v-if="book.member.is_new == 1" class="ft14 ftw500" style="color:red">预约会员(新客)：{{book.member_name}}</div>
												<div v-else class="ft14 ftw500" :style="{color:setting[book.status].memberColor}">预约会员：{{book.member_name}}</div>
												<div class="ft14 ftw500">预约状态：<span :style="{color:setting[book.status].mainColor}">{{book.status_means}}</span></div>
											</div>
											<div>
												<a-dropdown placement="bottomRight">
													<span class="more-act">
														<i class="iconfont iconmore_gray"></i>
													</span>
													<a-menu slot="overlay">
														<a-menu-item>
															<a class="menu-act" href="javascript:;" @click="showDetailAct(book)">
																<i class="iconfont ft14 iconsee"></i>
																<span class="ml10">查看详情</span>
															</a>
														</a-menu-item>
														<!-- 非充值卡支付确认到店 -->
														<a-menu-item v-if="book.status==2 && [4,5].includes(book.pay_type)">
															<a class="menu-act" href="javascript:;"  @click="arrivalAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">确认到店</span>
															</a>
														</a-menu-item>
														<!-- 充值卡支付确认到店 -->
														<a-menu-item v-if="book.status==2 && book.pay_type == 6">
															<a class="menu-act" href="javascript:;"  @click="showArrivalAppointItemDialog(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">确认到店</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if="book.status==2">
															<a class="menu-act" href="javascript:;"  @click="shuangAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">已爽约</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if="book.status==1 || book.status==2">
															<a class="menu-act" href="javascript:;"  @click="cancelAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">取消预约</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if="book.status==1">
															<a class="menu-act" href="javascript:;"  @click="goPay(book)">
																<i class="iconfont ft14"></i>
																<span class="ml10">发起充值卡支付</span>
															</a>
														</a-menu-item>
													</a-menu>
												</a-dropdown>
											</div>
										</div>

									</div>
								</template>
							</div>
						</a-table>

						<!-- 看板二 -->
						<a-table v-if="!theTableVisible" :columns="columns2" :data-source="mockData2" :pagination="false" bordered>
							<div slot="timeSlot" slot-scope="text, record">
								<div class="time-slot-cell">
									<div class="ft14 ftw600">{{ record.timeSlot }}</div>
								</div>
							</div>
							<div slot="appointments" slot-scope="text, record">
								<div v-for="(book, ii) in record.appointments" :key="ii" class="kanban-table-item">
									<!-- 预约详情 -->
									<div class="ml10 pr15 flex alcenter">
										<div class="flex alcenter">
											<div class="ft14 ftw500 mr10 pr10 border-r" :style="{color:setting[book.status].memberColor}">治疗师：{{book.technician_name}}</div>
											<div v-if="book.member.is_new == 1" class="ft14 ftw500 mr10 pr10 border-r" style="color:red">(新客)：{{book.member_name}}</div>
											<div v-else class="ft14 ftw500 mr10 pr10 border-r" :style="{color:setting[book.status].memberColor}">{{book.member_name}}</div>
											<div class="flex alcenter mr10 pr10 border-r">
												<!-- <div :style="{background: setting[book.status].mainColor}">{{book.start_time}}-{{book.end_time}}</div> -->
												<div :style="{color:setting[book.status].projectColor}" class="ml8 ft14 ftw400">{{book.project_name}}</div>
											</div>
											<div class="ft14 ftw500 mr10 pr10">预约状态：<span :style="{color:setting[book.status].mainColor}">{{book.status_means}}</span></div>
										</div>
										<div>
											<a-dropdown placement="bottomRight">
												<span class="more-act">
													<i class="iconfont iconmore_gray"></i>
												</span>
												<a-menu slot="overlay">
													<a-menu-item>
														<a class="menu-act" href="javascript:;" @click="showDetailAct(book)">
															<i class="iconfont ft14 iconsee"></i>
															<span class="ml10">查看详情</span>
														</a>
													</a-menu-item>
													<!-- 非充值卡支付确认到店 -->
													<a-menu-item v-if="book.status==2 && [4,5].includes(book.pay_type)">
														<a class="menu-act" href="javascript:;"  @click="arrivalAppointItemAct(book)">
															<i class="iconfont ft14 iconorder_operation_cancle"></i>
															<span class="ml10">确认到店</span>
														</a>
													</a-menu-item>
													<!-- 充值卡支付确认到店 -->
													<a-menu-item v-if="book.status==2 && book.pay_type == 6">
														<a class="menu-act" href="javascript:;"  @click="showArrivalAppointItemDialog(book)">
															<i class="iconfont ft14 iconorder_operation_cancle"></i>
															<span class="ml10">确认到店</span>
														</a>
													</a-menu-item>
													<a-menu-item v-if="book.status==2">
														<a class="menu-act" href="javascript:;"  @click="shuangAppointItemAct(book)">
															<i class="iconfont ft14 iconorder_operation_cancle"></i>
															<span class="ml10">已爽约</span>
														</a>
													</a-menu-item>
													<a-menu-item v-if="book.status==1 || book.status==2">
														<a class="menu-act" href="javascript:;"  @click="cancelAppointItemAct(book)">
															<i class="iconfont ft14 iconorder_operation_cancle"></i>
															<span class="ml10">取消预约</span>
														</a>
													</a-menu-item>
													<a-menu-item v-if="book.status==1">
														<a class="menu-act" href="javascript:;"  @click="goPay(book)">
															<i class="iconfont ft14"></i>
															<span class="ml10">发起充值卡支付</span>
														</a>
													</a-menu-item>
												</a-menu>
											</a-dropdown>
										</div>
									</div>
								</div>
							</div>
						</a-table>

						<div class="flex center mt20">
							<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current"
								:pageSize="pagination.pageSize" show-less-items />
						</div>

						<div v-if="showDetailVisible">
							<order-item-detail :visible="showDetailVisible" :order="order" @cancel="cancelShowDetail"
								@sureAppoint="sureAppoint" @cancelAppoint="cancelAppoint" @sureWriteOff="sureWriteOff"></order-item-detail>
						</div>

						<div v-if="cancelAppointVisible">
							<cancel-appoint-item :appointment_item_id="appointment_item_id" :visible="cancelAppointVisible"
								@cancel="cancelCancelAppoint" @ok="okCancelAppoint"></cancel-appoint-item>
						</div>

						<div v-if="addAppointmentVisible">
							<add-appointment :visible="addAppointmentVisible" @cancel="cancelAddAppointment"
								@ok="okAddAppointment"></add-appointment>
						</div>
					</div>
				</div>
			</div>
		</a-spin>

		<!-- 确认到店弹框（充值卡支付专用）- 极简版 -->
		<div v-if="arrivalAppointVisible">
			<a-modal
				:visible="arrivalAppointVisible"
				title="确认到店核销"
				@cancel="cancelArrivalAppoint"
				:maskClosable="false"
				:destroyOnClose="true"
				width="400px"
				:footer="null"
			>
				<div class="simple-arrival-dialog">
					<!-- 实际支付金额 - 只读显示 -->
					<div class="amount-row">
						<span class="label">实际支付金额：</span>
						<span class="value readonly">￥{{ actualAmount.toFixed(2) }}</span>
					</div>
					
					<!-- 核销金额 - 可编辑 -->
					<div class="amount-row">
						<span class="label">核销金额：</span>
						<a-input-number
							v-model="verifyAmount"
							:precision="2"
							:min="0"
							:max="999999"
							:step="0.01"
							placeholder="请输入核销金额"
							style="width: 150px"
							size="large"
						/>
					</div>
					
					<!-- 按钮组 -->
					<div class="button-group">
						<a-button @click="cancelArrivalAppoint" size="large">取消</a-button>
						<a-button 
							type="primary" 
							@click="confirmArrivalAppoint" 
							:loading="arrivalLoading"
							size="large"
							style="margin-left: 12px;"
						>
						确认
						</a-button>
					</div>
				</div>
			</a-modal>
		</div>

	</div>
</template>

<script>
import helper from '../../common/helper.js';
import orderItemDetail from './components/order/modal/itemDetail.vue';
import cancelAppointItem from './components/order/modal/detail/modal/cancelAppointItem.vue';
import addAppointment from './components/order/modal/addAppointment.vue';
export default {
	components: {
		orderItemDetail,
		cancelAppointItem,
		addAppointment,
	},
	data() {
		return {
			loading: false,
			showDetailVisible: false,
			cancelAppointVisible: false,
			addAppointmentVisible: false,
			appointment_item_id: 0,
			order: {},
			settings: [
				{ status: 1, status_means: '待支付', mainColor: '#4772FF', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 2, status_means: '待到店', mainColor: '#FF7519', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 3, status_means: '部分完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 4, status_means: '已完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 5, status_means: '部分取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 6, status_means: '已取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 7, status_means: '部分爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 8, status_means: '已爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' },
			],
			setting: [],
			week: 0,
			selectIndex: 0,
			today: null,
			days: [],
			pagination: {
				current: 1,
				pageSize: 50, // 每页条数
				total: 0,
			},
			search: {
				mendian_id: 0,
				status: 0,
				start_time: '',
				end_time: '',
				technician:'',
				member:'',
			},
			datas: [],
			mendians: [],
			mockData: [
				// { date: '9点-10点', bookProject: [{ name: 'xxx服务1', technicianId: 1 }, { name: 'xxx服务4', technicianId: 1 }, { name: 'xxx服务6', technicianId: 1 }] },
				// { date: '10点-11点', bookProject: [{ name: 'xxx服务2', technicianId: 2 }] },
				// { date: '11点-12点', bookProject: [{ name: 'xxx服务3', technicianId: 3 }, { name: 'xxx服务5', technicianId: 1 }, { name: 'xxx服务7', technicianId: 1 }] },
			],
			mockDataTechnician: [
				// { name: '李大良AA', technicianId: 1 },
				// { name: '张三', technicianId: 2 },
				// { name: '张三', technicianId: 3 },
				// { name: '张三', technicianId: 4 },
				// { name: '张三', technicianId: 5 },
				// { name: '张三', technicianId: 6 },
				// { name: '张三', technicianId: 7 },
				// { name: '张三', technicianId: 8 },
				// { name: '张三', technicianId: 9 },
				// { name: '张三', technicianId: 10 },
				// { name: '张三', technicianId: 11 },
				// { name: '张三', technicianId: 12 },
			],
			columns: [],
			columns2: [],
			theTableVisible: true,
			mockData2: [],
			payLoading: false,
			arrivalAppointVisible: false, // 确认到店弹框显示状态
			currentBookItem: {}, // 当前操作的预约项目
			verifyAmount: 0, // 核销金额（可编辑）
			actualAmount: 0, // 实际支付金额（只读）
			arrivalLoading: false, // 确认到店加载状态
		}
	},
	created() {
		this.getMendians();

		this.setting[1] = { status: 1, status_means: '待支付', mainColor: '#4772FF', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[2] = { status: 2, status_means: '待到店', mainColor: '#FF7519', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[3] = { status: 3, status_means: '部分完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[4] = { status: 4, status_means: '已完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[5] = { status: 5, status_means: '部分取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[6] = { status: 6, status_means: '已取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[7] = { status: 7, status_means: '部分爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[8] = { status: 8, status_means: '已爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' };

		let days = helper.getWeekArr();
		this.days = days;
		this.today = helper.getTimeArr();//获取今天
		this.selectIndex = this.today.w;

		this.getLists();
	},

	computed: {
		getDays() {
			if (this.today == null) return [];
			let arr = new Array;
			for (var a in this.days) {
				arr.push({
					today: this.days[a].today,
					md: this.days[a].md,
					wd: this.days[a].wd,
					day: this.days[a].y + '-' + this.days[a].m + '-' + this.days[a].d,
				});
			}
			return arr;
		}
	},
	methods: {
		getMendians() {
			this.$http.api('admin/getAllMendian').then(res => {
				this.mendians = res.mendian;

				this.getTechnicianList();
			}).catch(res => {
				console.log(res);
			});
		},

		getTechnicianList() {
			this.$http.api('admin/getTechnicianList', {
				page: 1,
				limit: 50,
				mendian_id: this.search.mendian_id,
			}).then(res => {
				this.mockDataTechnician = res.list;
				console.log('this.mockDataTechnician',this.mockDataTechnician)

				this.columns = [
					{
						title: '时间段',
						dataIndex: 'date',
						fixed: this.mockDataTechnician.length > 5 ? 'left' : false,
						width: 100
					},
					...this.mockDataTechnician.map(r => ({
						title: r.name,
						dataIndex: r.technician_id,
						scopedSlots: { customRender: `bookDetail-${r.technician_id}` },
						width: 200
					}))
				]

				this.columns2 = [
					{
						title: '时间段',
						dataIndex: 'timeSlot',
						scopedSlots: { customRender: 'timeSlot' },
						// fixed: 'left',
						width: 120
					},
					{
						title: '预约详情',
						dataIndex: 'appointments',
						scopedSlots: { customRender: 'appointments' },
						width: 600
					}
				]
			}).catch(res => {
				console.log(res);
			});
		},

		getLists() {
			if (this.loading == true) return;
			this.loading = true;
			this.$http.api('admin/showAppointmentKanbanNew', {
				limit: this.pagination.pageSize,
				page: this.pagination.current,
				day: this.getDays[this.selectIndex].day,
				mendian_id: this.search.mendian_id,
				technician: this.search.technician,
				member: this.search.member,
			}).then(res => {
				this.mockData = res.datas;
				console.log('this.mockData', this.mockData)
				
				if (!this.theTableVisible) {
					this.transformDataForTable2();
				}
				
				this.loading = false;
			}).catch(res => {
				console.log(res);
				this.loading = false;
			})
		},

		// 确认预约（父单）
		sureAppointAct(index1, index2) {
			this.$confirm({
				title: '确认这个预约吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/sureAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('确认成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 确认到店（父单）
		arrivalAppointAct(index1, index2) {
			this.$confirm({
				title: '确认已经到店了吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/arrivalAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('操作成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 确认爽约（父单）
		shuangAppointAct(index1, index2) {
			this.$confirm({
				title: '确认已经爽约了吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/shuangAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('操作成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 查看订单详情
		showDetailAct(order) {
			console.log('order',order)
			this.order = order;
			this.showDetailVisible = true;
		},
		cancelShowDetail() {
			this.showDetailVisible = false;
		},
		sureAppoint() {
			this.showDetailVisible = false;
			this.getLists();
		},
		cancelAppoint() {
			this.showDetailVisible = false;
			this.getLists();
		},
		sureWriteOff() {
			this.showDetailVisible = false;
			this.getLists();
		},

		// 取消预约项
		cancelAppointItemAct(order) {
			this.appointment_item_id = order.appointment_item_id,
			this.cancelAppointVisible = true;
		},
		cancelCancelAppoint() {
			this.cancelAppointVisible = false;
		},
		okCancelAppoint() {
			this.cancelAppointVisible = false;
			this.getLists();
		},

		// 新增预约
		addAppointmentAct() {
			this.addAppointmentVisible = true;
		},
		cancelAddAppointment() {
			this.addAppointmentVisible = false;
		},
		okAddAppointment() {
			this.addAppointmentVisible = false;
			this.getLists();
		},

		getUpWeek() {
			this.week = this.week - 1;
			let days = helper.getWeekArr(this.week);
			this.days = days;
			this.getDatas();
		},
		getDownWeek() {
			this.week = this.week + 1;
			let days = helper.getWeekArr(this.week);
			this.days = days;
			this.selectIndex = 0;
			this.getDatas();
		},

		changeDay(index) {
			this.selectIndex = index;
			this.getDatas();
		},

		getDatas() {
			this.loading = false;
			this.pagination.current = 1;
			this.getLists();
		},

		pageChange(e) {
			this.pagination.current = parseInt(e);
			this.getLists();
		},
		changeMendian() {
			this.getTechnicianList();
			this.pagination.current = 1;
			this.getLists();
		},
		searchAct(){
			this.pagination.current = 1;
			this.getLists();
		},
		cancelAct(){
			this.search.technician = '';
			this.search.member = '';
			this.pagination.current = 1;
			this.getLists();
		},

		transformDataForTable2() {
			if (!this.mockData || this.mockData.length === 0) {
				this.mockData2 = [];
				return;
			}

			this.mockData2 = this.mockData.map(timeSlotData => {
				return {
					timeSlot: timeSlotData.date,
					appointments: timeSlotData.bookProject || []
				};
			});
			console.log('this.mockData2',this.mockData2)
		},

		// 显示确认到店弹框（充值卡支付专用）
		showArrivalAppointItemDialog(book) {
			this.currentBookItem = book;
			
			// 实际支付金额直接显示，从 book 对象获取，确保转换为数字
			let actualAmt = book.card_pay || 0;
			// 如果是字符串，转换为数字
			this.actualAmount = typeof actualAmt === 'string' ? parseFloat(actualAmt) || 0 : Number(actualAmt) || 0;

			// 核销金额初始值从 book 获取，允许修改，确保转换为数字
			let verifyAmt = book.card_pay || 0;
			this.verifyAmount = typeof verifyAmt === 'string' ? parseFloat(verifyAmt) || 0 : Number(verifyAmt) || 0;
			
			this.arrivalAppointVisible = true;
		},

		// 取消确认到店弹框
		cancelArrivalAppoint() {
			this.arrivalAppointVisible = false;
			this.currentBookItem = {};
			this.actualAmount = 0;
			this.verifyAmount = 0;
		},

		// 确认到店操作
		confirmArrivalAppoint() {
			// 简单验证
			if (this.verifyAmount <= 0) {
				this.$message.warning('核销金额不能小于0');
				return;
			}
			
			this.doConfirmArrival();
		},

		// 充值卡确认到店项（子单）
		doConfirmArrival() {
			if (this.arrivalLoading) return;
			this.arrivalLoading = true;
			const item_id = this.currentBookItem.appointment_item_id;
			// console.log('item_id',item_id)
			// console.log('verifyAmount',this.verifyAmount)
			
			this.$http.api('admin/arrivalAppointmentItem', {
				appointment_item_id: item_id,
				verification_price: this.verifyAmount
			}).then(res => {
				this.$message.success('确认到店成功', 1, () => {
					this.arrivalLoading = false;
					this.cancelArrivalAppoint();
					
					// 重新获取订单数据
					this.getLists();
				});
			}).catch(res => {
				console.log(res);
				this.arrivalLoading = false;
				this.$message.error(res.message || '操作失败');
			});
		},

		// 确认到店项（子单）
		arrivalAppointItemAct(book){
			let item_id = book.appointment_item_id
			// 显示确认弹框
			this.$confirm({
				title: '确认到店',
				content: '确定要将此预约标记为已到店吗？',
				okText: '确认',
				cancelText: '取消',
				type: 'warning',
				onOk: () => {
					// 用户点击确认后执行的操作
					this.$http.api('admin/arrivalAppointmentItem',{
						appointment_item_id:item_id,
					}).then(res=>{
						this.$message.success('操作成功',1,()=>{
							
							// 重新获取订单数据
							this.getLists();
						});
						
					}).catch(res=>{
						console.log(res);
					})
				},
				onCancel: () => {
					// 用户点击取消，什么都不做
					console.log('用户取消操作');
				}
			});
		},

		// 已爽约（子单）
		shuangAppointItemAct(book){
			let item_id = book.appointment_item_id
			// 显示确认弹框
			this.$confirm({
				title: '确认已爽约',
				content: '确定要将此预约标记为已爽约吗？',
				okText: '确认',
				cancelText: '取消',
				type: 'warning',
				onOk: () => {
					// 用户点击确认后执行的操作
					this.$http.api('admin/shuangAppointmentItem',{
						appointment_item_id:item_id,
					}).then(res=>{
						this.$message.success('操作成功',1,()=>{
							
							// 重新获取订单数据
							this.getLists();
						});
						
					}).catch(res=>{
						console.log(res);
					})
				},
				onCancel: () => {
					// 用户点击取消，什么都不做
					console.log('用户取消操作');
				}
			});
		},

		switchTable(){
			this.theTableVisible = !this.theTableVisible;
			if (!this.theTableVisible) {
				this.$nextTick(() => {
					this.transformDataForTable2();
				});
			}
		},

		// 去支付
		goPay(book) {
			const appointment_id = book.appointment_id;
			console.log('appointment_id',appointment_id)

			this.$http.api('admin/goCheckPay', {
				appointment_id: appointment_id,
			}).then(res => {
				console.log('支付响应:', res);
				this.$message.success('支付确认中，请稍等', 1 , ()=>{

					// 显示确认弹框
					this.$confirm({
						title: '支付确认',
						content: '确定要将此预约发起支付吗？',
						okText: '确认',
						cancelText: '取消',
						type: 'warning',
						onOk: () => {
							// 用户点击确认后执行的操作
							this.payAppointOrder(res);
						},
						onCancel: () => {
							// 用户点击取消，什么都不做
							console.log('用户取消操作');
						}
					});
				});
			}).catch(err => {
				console.error(err);
				this.$message.error('支付请求失败');
			});
		},

		payAppointOrder(res)
		{
			const pay_type = res.data.pay_type;
			const appointment_id = res.data.appointment_id;
			const member_once_card_id = res.data.member_once_card_id;
			if(!pay_type || !appointment_id || !member_once_card_id){
				this.$message.error('支付请求参数失败');
				return;
			}

			if (this.payLoading) return;
			this.payLoading = true;
			this.$http.api('miniapp/staff/appoint/payAppointOrder', {
				pay_type: pay_type,
				appointment_id: appointment_id,
				member_once_card_id: member_once_card_id
			}).then(res => {
				this.$message.success('支付成功', 1, () => {
					this.payLoading = false;
					
					// 重新获取订单数据
					this.getLists();
				});
			}).catch(err => {
				console.error(err);
				this.payLoading = false;
				this.$message.error('支付请求失败');
			});
		}
	}
}
</script>

<style scoped>
.setting-item {
	width: 14px;
	height: 14px;
}

.kanban-table-header {
	width: 100%;
	height: 60px;
	background: #FFFFFF;
}

.kanban-table-header-left {
	width: 170px;
	height: 60px;
}

.kanban-table-header-right {
	width: calc(100% - 170px);
	height: 60px;
	border: 1px solid #EBEDF5;
	border-left: none;
	padding: 0px 20px;
	line-height: 1;
}

.last-week-button {
	width: 90px;
	height: 40px;
	background: #FFFFFF;
	border-radius: 4px;
	border: 1px solid #EBEDF5;
	font-size: 14px;
	font-weight: 500;
	color: #656A75;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}

.this-week-item {
	height: 40px;
	font-size: 12px;
	font-weight: 500;
	color: #A6AEC2;
	width: 10%;
	margin-left: 3%;
	margin-left: 3%;
	cursor: pointer;
}

.this-week-item.on {
	height: 40px;
	background: #4772FF;
	border-radius: 4px;
	color: #FFFFFF;
}

.next-week-button {
	width: 90px;
	height: 40px;
	background: #FFFFFF;
	border-radius: 4px;
	border: 1px solid #4772FF;
	font-size: 14px;
	font-weight: 500;
	color: #4772FF;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}

/* 添加切换按钮样式 */
.switch-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 120px;
	height: 40px;
	background: linear-gradient(135deg, #4772FF 0%, #5B8CFF 100%);
	border-radius: 6px;
	color: white;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 2px 8px rgba(71, 114, 255, 0.3);
}

.switch-btn:hover {
	background: linear-gradient(135deg, #3A5FE0 0%, #4772FF 100%);
	box-shadow: 0 4px 12px rgba(71, 114, 255, 0.4);
	transform: translateY(-1px);
}

.switch-btn:active {
	transform: translateY(0);
	box-shadow: 0 2px 6px rgba(71, 114, 255, 0.3);
}

.kanban-table-item {
	border-bottom: 1px solid #e8e8e8;
	padding: 5px 0;
}

.kanban-table-item:last-child {
	border: none;
}

.border-r {
	border-right: 1px solid #e8e8e8;
}

/* 确认到店样式弹框样式-start */
.simple-arrival-dialog {
  padding: 20px 0;
  text-align: center;
}

.amount-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 0 20px;
}

.amount-row:last-of-type {
  margin-bottom: 32px;
}

.label {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.value {
  font-size: 28px;
  font-weight: 600;
}

.value.readonly {
  color: darkorange;
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}
/* 确认到店样式弹框样式-end */

</style>
